





































import Vue from 'vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import { KSTItem, KTRItem, SollHabenItem } from '@/types/service-response'
import { SaveFibuStepPayload } from '@/types/payload'
import { ProjectBookingFibu } from '@/model/project/ProjectBookingFibu'

interface ComponentData {

}

export default Vue.extend({
  name: 'BookingAssistant13',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {
    step5Data: Array as () => ProjectBookingFibu[],
    value: Object as () => SaveFibuStepPayload,
    sollHabenList: Array as () =>SollHabenItem[],
    kstList: Array as () =>KSTItem[],
    ktrList: Array as () =>KTRItem[]
  },

  data (): ComponentData {
    return {

    }
  },

  watch: {

  },

  computed: {
    data: {
      get(): SaveFibuStepPayload {
        return this.value
      },

      set(val: SaveFibuStepPayload): void {
        this.$emit('input', val)
      }
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {

  },

  mounted () {

  }
})
